
import { atom } from "jotai";
import { invoiceFilterGroups } from "./predicate";
import { InvoiceFilterAtom } from "./type";
const invoiceFilters: InvoiceFilterAtom = {
  filterGroup: invoiceFilterGroups,
  filterValues: {},
  activeFilterKeys: ["due_date_range", "date_range", "statuses"],
  sorting: {
    sort_col: "ISSUE_DATE",
    order: 'DESC',
  },
  ui_filters: {
    view_status: "ALL",
  },
};
export const invoiceFiltersAtom = atom(invoiceFilters);
